import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import ImageContainer from '../ImageContainer';
import { FormValues } from '../../types';
import { useTranslation } from 'services/localization';
import { uploadImage } from '../../utils';
import * as NotificationActions from 'actions/NotificationActions';
import * as ShopSelectors from 'selectors/ShopSelectors';

export interface Props {
	sectionIndex: number;
	contentIndex: number;
}
const ImageContentUploader = (props: Props) => {
	const { sectionIndex, contentIndex } = props;

	const { control, watch } = useFormContext<FormValues>();
	const [loading, setLoading] = useState<boolean>(false);
	const shopId = useSelector(ShopSelectors.activeShopId)!;
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const currentImage = watch(
		`onlineLayout.about.customContent.sections.${sectionIndex}.content.${contentIndex}.src`,
	);

	const hasUploadedImage = !!currentImage;

	return (
		<Controller
			name={`onlineLayout.about.customContent.sections.${sectionIndex}.content.${contentIndex}.src`}
			control={control}
			render={({ field }) => (
				<>
					<Stack
						justifyContent="center"
						alignItems="center"
						sx={{
							height: '200px',
							width: '100%',
							background: (theme) => theme.palette.border.divider,
							border: (theme) =>
								!hasUploadedImage ? `1px dashed ${theme.palette.border.inputOutline}` : undefined,
							borderRadius: (theme) => theme.spacing(0.5),
						}}
					>
						<ImageContainer
							value={field.value}
							onImageUpload={(e) => {
								try {
									setLoading(true);
									uploadImage(e, field.onChange, {
										shopId,
										width: 1280,
										height: 600,
									});
									setLoading(false);
								} catch (e) {
									dispatch(
										NotificationActions.showNotification({
											message: t('common:errors.wrongFileType', 'Wrong file type'),
											variant: 'error',
											autoDismissMs: 2000,
										}),
									);
								}
							}}
							onDelete={() => field.onChange(null)}
							loading={loading}
							objectFit={'cover'}
						/>
					</Stack>
				</>
			)}
		/>
	);
};

export default ImageContentUploader;
